<template>
   <i class='iconfont' :class="type" :style="{fontSize:size}"></i>
</template>
<script >
import {
  defineComponent,
  reactive,
  toRefs
} from 'vue';
export default defineComponent({
  name: 'XIcon',
  components: {},
  props: {
    type: {
      type: String
    },
    size: String
  },
  setup(props) {
    const data = reactive({});
    const refData = toRefs(data);
    return { ...refData };
  }
});
</script>
<style  lang='scss' scoped >
</style>